import * as React from 'react';
import _ from 'lodash';

import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  onImageClick?(index: number): void;
  children?: React.ReactNode;
  imageUrl: string;
  alt: string;
  backgroundColor?: string;
  index: number;
  className?: string;
  isLink?: boolean;
}

interface State {
  currentImageUrl?: string;
}

export default class GalleryImage extends BaseComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      currentImageUrl: props.imageUrl,
    };
  }

  componentDidMount() {
    this.handleNewImageUrl(this.props.imageUrl);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.imageUrl !== this.props.imageUrl) {
      this.handleNewImageUrl(this.props.imageUrl);
    }
  }

  handleNewImageUrl(newImageUrl: string) {
    requestIdleCallback(
      () => {
        const img = new Image();
        img.onload = () => {
          this.setState({
            currentImageUrl: newImageUrl,
          });
        };
        img.src = newImageUrl;
      },
      { timeout: 17 }
    );
  }

  handleClick() {
    const { index, onImageClick } = this.props;
    if (onImageClick) {
      onImageClick(index);
    }
  }

  getImageStyle(url?: string) {
    if (_.isNil(url)) {
      return { backgroundColor: this.props.backgroundColor };
    }

    return {
      backgroundColor: this.props.backgroundColor,
      backgroundImage: `url(${url})`,
    };
  }

  onKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      this.handleClick();
    }
  };

  getRole() {
    const { onImageClick, isLink } = this.props;
    return isLink ? 'link' : onImageClick ? 'button' : undefined;
  }

  render() {
    const { className, alt, onImageClick, children } = this.props;
    const { currentImageUrl } = this.state;
    // TODO: (BP 3-22-22) use more modern approach for rendering banner images with <a> and <img> tags and object-fit / object-position CSS props
    return (
      <div
        role={this.getRole()}
        tabIndex={0}
        className={className}
        onClick={onImageClick ? this.handleClick : undefined}
        onKeyPress={this.onKeyPress}
        aria-label={onImageClick ? 'View image (opens a dialog)' : undefined}
      >
        <div
          className="LargeImageGallery-imageElement"
          aria-label={alt}
          style={this.getImageStyle(currentImageUrl)}
          role="img"
        />
        {children}
      </div>
    );
  }
}
